import React, { useEffect, useState } from "react";
import { Button, Col, Container, Dropdown, Form, Image, Row } from "react-bootstrap";
//-------- HEADER COMPONENT IMPORT ---------//
import WithoutImageHeader from "../../../Helper/withoutImageHeader";
//------------ CONSTANTS IMPORT ------------//
import { faAngleDown, faAngleUp, faPlus, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import * as Constants from "../../../Helper/constants/constants";
import TagsInput from "react-tagsinput";
import 'react-tagsinput/react-tagsinput.css';
import AssignMedicineFunction from "./function";


const AssignMedicine = () => {
    const {
        breadcrumData,
        breadcrumItem,
        tags,
        values,
        isError,
        handleChange,
        handleSubmit,
        loader,
        anotherMedicine,
        numMedicine
    } = AssignMedicineFunction()

    return (
        <div className="assign_medicine_section manage_tags">
            <WithoutImageHeader
                header={Constants.ASSIGN_MEDICINE}
                breadcrumData={breadcrumData}
                breadcrumItem={breadcrumItem}
                lefticon={'menu'}
            />
            <div className="assign_medicine_area">
                <Container>
                    <Row>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                            <div className="medicine_main_area">
                                <div className="form">
                                    <Form>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                            <Form.Group className="form-group">
                                                <Form.Label>Brand Name<span>*</span></Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder={'Enter brand name'}
                                                    value={values && values.brandName}
                                                    className={isError.brandName.message
                                                        ? "error_border"
                                                        : ""}
                                                    onChange={(e) => handleChange("brandName", e.target.value)}
                                                />
                                                {isError.brandName.message ? (
                                                    <p className="text-danger mt-2">
                                                        {isError.brandName.message}
                                                    </p>
                                                ) : null}
                                            </Form.Group>
                                            <Form.Group className="form-group">
                                                <Form.Label>Medicine Name<span>*</span></Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder={'Enter Medicine'}
                                                    value={values && values.medicine}
                                                    className={isError.medicine.message
                                                        ? "error_border"
                                                        : ""}
                                                    onChange={(e) => handleChange("medicine", e.target.value)}
                                                />
                                                {isError.medicine.message ? (
                                                    <p className="text-danger mt-2">
                                                        {isError.medicine.message}
                                                    </p>
                                                ) : null}
                                            </Form.Group>
                                            <Form.Group className="form-group">
                                                <Form.Label>Salt<span>*</span></Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder={'Enter salt here'}
                                                    value={values && values.salt}
                                                    className={isError.salt.message
                                                        ? "error_border"
                                                        : ""}
                                                    onChange={(e) => handleChange("salt", e.target.value)}
                                                />
                                                {isError.salt.message ? (
                                                    <p className="text-danger mt-2">
                                                        {isError.salt.message}
                                                    </p>
                                                ) : null}
                                            </Form.Group>
                                        </Col>
                                        <Row>
                                            <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                                                <Form.Group className="form-group">
                                                    <Form.Label>Dosage<span>*</span></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={'Enter Dosage here'}
                                                        value={values && values.dosage}
                                                        className={isError.dosage.message
                                                            ? "error_border"
                                                            : ""}
                                                        onChange={(e) => handleChange("dosage", e.target.value)}
                                                    />
                                                    {isError.dosage.message ? (
                                                        <p className="text-danger mt-2">
                                                            {isError.dosage.message}
                                                        </p>
                                                    ) : null}
                                                </Form.Group>
                                            </Col>
                                            <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                                                <Form.Group className="form-group">
                                                    <Form.Label>Route</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={'Enter route here'}
                                                        value={values && values.route}
                                                        className={isError.route.message
                                                            ? "error_border"
                                                            : ""}
                                                        onChange={(e) => handleChange("route", e.target.value)}
                                                    />
                                                    {isError.route.message ? (
                                                        <p className="text-danger mt-2">
                                                            {isError.route.message}
                                                        </p>
                                                    ) : null}
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <div className="tag_area">
                                            <h6>Frequency<span>*</span></h6>
                                            <TagsInput
                                                value={values && values.tags}
                                                onChange={(e) => handleChange("tags", e)}
                                            />
                                            {isError.tags.message ? (
                                                <p className="text-danger mt-2">
                                                    {isError.tags.message}
                                                </p>
                                            ) : null}
                                        </div>
                                    </Form>
                                </div>
                                {numMedicine &&
                                    numMedicine.length > 0 ?
                                    numMedicine.map((item, i) => {
                                        return (
                                            <div className="form_area" key={i}>
                                                <div className="icon_cross" >
                                                    <a href="javascript:;" onClick={() => anotherMedicine(item)}><FontAwesomeIcon icon={faXmark} /></a>
                                                </div>
                                                <Form>
                                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                        <Form.Group className="form-group">
                                                            <Form.Label>Brand Name<span>*</span></Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder={'Enter brand name'}
                                                                value={values && values.brandName}
                                                                className={isError.brandName.message
                                                                    ? "error_border"
                                                                    : ""}
                                                                onChange={(e) => handleChange("brandName", e.target.value)}
                                                            />
                                                            {isError.brandName.message ? (
                                                                <p className="text-danger mt-2">
                                                                    {isError.brandName.message}
                                                                </p>
                                                            ) : null}
                                                        </Form.Group>
                                                        <Form.Group className="form-group">
                                                            <Form.Label>Medicine Name<span>*</span></Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder={'Enter Medicine'}
                                                                value={values && values.medicine}
                                                                className={isError.medicine.message
                                                                    ? "error_border"
                                                                    : ""}
                                                                onChange={(e) => handleChange("medicine", e.target.value)}
                                                            />
                                                            {isError.medicine.message ? (
                                                                <p className="text-danger mt-2">
                                                                    {isError.medicine.message}
                                                                </p>
                                                            ) : null}
                                                        </Form.Group>
                                                        <Form.Group className="form-group">
                                                            <Form.Label>Salt<span>*</span></Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder={'Enter salt here'}
                                                                value={values && values.salt}
                                                                className={isError.salt.message
                                                                    ? "error_border"
                                                                    : ""}
                                                                onChange={(e) => handleChange("salt", e.target.value)}
                                                            />
                                                            {isError.salt.message ? (
                                                                <p className="text-danger mt-2">
                                                                    {isError.salt.message}
                                                                </p>
                                                            ) : null}
                                                        </Form.Group>
                                                    </Col>
                                                    <Row>
                                                        <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                                                            <Form.Group className="form-group">
                                                                <Form.Label>Dosage<span>*</span></Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder={'Enter Dosage here'}
                                                                    value={values && values.dosage}
                                                                    className={isError.dosage.message
                                                                        ? "error_border"
                                                                        : ""}
                                                                    onChange={(e) => handleChange("dosage", e.target.value)}
                                                                />
                                                                {isError.dosage.message ? (
                                                                    <p className="text-danger mt-2">
                                                                        {isError.dosage.message}
                                                                    </p>
                                                                ) : null}
                                                            </Form.Group>
                                                        </Col>
                                                        <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                                                            <Form.Group className="form-group">
                                                                <Form.Label>Route</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder={'Enter route here'}
                                                                    value={values && values.route}
                                                                    className={isError.route.message
                                                                        ? "error_border"
                                                                        : ""}
                                                                    onChange={(e) => handleChange("route", e.target.value)}
                                                                />
                                                                {isError.route.message ? (
                                                                    <p className="text-danger mt-2">
                                                                        {isError.route.message}
                                                                    </p>
                                                                ) : null}
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                    <div className="tag_area">
                                                        <h6>Frequency<span>*</span></h6>
                                                        <TagsInput
                                                            value={tags}
                                                            inputValue={tags}
                                                        />
                                                    </div>
                                                </Form>
                                            </div>
                                        )
                                    })
                                    : null}
                                <div className="more_btn_area" onClick={() => anotherMedicine()}>
                                    <a href="javascript:;" className="btn btn-primary" ><FontAwesomeIcon icon={faPlus} className="plus_icon" />Add More</a>
                                </div>
                                <div className="btn_area">
                                    <Button
                                        className="cancelBtn"
                                        type="button"
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        className="submitBtn"
                                        type="submit"
                                        onClick={() => handleSubmit()}
                                    >
                                        Submit
                                    </Button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
};

export default AssignMedicine;
